export class ConstantsTexte {
  static readonly ANWENDUNGSNAME: string = 'BauKost';
  static readonly ENTWICKLUNGSTEXT: string = '';

  static readonly INVESTITIONSBEDARF_NACH_KOSTENBLOECKEN: string = 'Investitionsbedarf nach Kostenblöcken';

  static readonly INVESTITIONSBEDARF_IN_EURO: string = 'Investitionsbedarf in €';
  static readonly INVESTITIONSBEDARF_IN_EURO_M3: string = ConstantsTexte.INVESTITIONSBEDARF_IN_EURO + '/m³';
  static readonly INVESTITIONSBEDARF_IN_EURO_M2: string = ConstantsTexte.INVESTITIONSBEDARF_IN_EURO + '/m²';
  static readonly INVESTITIONSBEDARF_IN_EURO_TP: string = ConstantsTexte.INVESTITIONSBEDARF_IN_EURO + '/TP';

  static readonly INVESTITIONSBEDARF_JE_M3_NUTZVOLUMEN_NACH_KB: string = 'Investitionsbedarf je m³ Nutzvolumen nach Kostenblöcken';
  static readonly INVESTITIONSBEDARF_JE_M2_NUTZFLAECHE_NACH_KB: string = 'Investitionsbedarf je m² Nutzfläche nach Kostenblöcken';

  static readonly INVESTITIONSBEDARF_JE_TP_NACH_KB: string = 'Investitionsbedarf je Tierplatz nach Kostenblöcken';
  static readonly INVESTITIONSBEDARF_NUTZUNGSDAUER: string = 'Investitionsbedarf nach Nutzungsdauer';

  static readonly NETTOFLAECHEN_JE_TP_NACH_FKT: string = 'Nettoflächen je Tierplatz nach Funktionsbereichen';

  static readonly BRUTTOFLAECHEN_JE_TP_NACH_FKT: string = 'Bruttoflächen je Tierplatz nach Funktionsbereichen';

  static readonly INVESTITIONSBEDARF_JE_M2_BRUTTO_FKTFLAECH: string = 'Investitionsbedarf je m² Brutto-Funktionsfläche';

  static readonly JAEHRLICHE_GEBAEUDEKOSTEN: string = 'Jährliche Gebäudekosten';

  static readonly FLAECHE_IN_M2_TP: string = 'Fläche in m²/TP';

  static readonly BAULICHE_ANLAGE_WAEHLEN: string = 'Bauliche Anlage wählen';
  static readonly TIERKATEGORIE_WAEHLEN: string = 'Tierkategorie wählen';

  static readonly ABSCHREIBUNGEN: string = 'Abschreibungen';
  static readonly ZINSKOSTEN: string = 'Zinskosten';
  static readonly UNTERHALTUNG: string = 'Unterhaltung';
  static readonly VERSICHERUNGEN: string = 'Versicherungen';

  static readonly LANG_30: string = 'lang (30 Jahre)';
  static readonly MITTEL_15: string = 'mittel (15 Jahre)';
  static readonly KURZ_10: string = 'kurz (10 Jahre)';

  static readonly EINSTELLUNG_TEXT_WECHSEL: string = 'Es gibt Änderungen, die nicht übernommen wurden.\nWollen Sie wirklich den Tab wechseln ohne die Änderungen zu übernehmen?\nZum Übernehmen der Änderungen bitte auf Aktualisieren klicken.';
  static readonly EINSTELLUNG_ZURUECKGESETZT: string = "Die Daten wurden zurückgesetzt.";
  static readonly EINSTELLUNG_UNGUELTIGE_EINGABE_PREISFAKTOR: string = "Ungültige Eingabe beim Preisfaktor! Bitte korrigieren.";
  static readonly FEHLER_KEINE_GEBAEUDE_GEFUNDEN: string = 'Fehler: Keine Gebäudedaten gefunden.';
 
}
